<main class="contenido-principal">
  <!-- Sección Hero con Slider -->
  <section class="seccion-heroe">
    <div class="slides-container">
      @for (slide of slides; track $index) {
        <div class="slide" [class.active]="currentSlide === $index" [attr.data-slide]="$index">
          <div class="contenido-heroe">
            <div class="texto-heroe">
              <div class="circulo-azul"></div>
              <div class="cuadro-texto">
                <h1>{{ slide.title }}</h1>
                <p>{{ slide.description }}</p>
                <button class="boton-principal">
                  <a routerLink="/contacto">Cotiza Aquí</a>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    
    <div class="indicadores">
      @for (slide of slides; track $index) {
        <span class="indicador" 
              [class.activo]="currentSlide === $index" 
              [attr.data-slide]="$index"
              (click)="goToSlide($index)"></span>
      }
    </div>
  </section>

  <!-- Sección Servicios -->
  <section class="seccion-servicios">
    <div class="contenedor">
      <h2>Para cada necesidad, una <span>solución.</span></h2>
      <p>Con años de experiencia en el sector, ofrecemos soluciones <span>eficientes y personalizadas</span> para cada requerimiento de nuestros clientes.</p>
      <div class="cuadricula-servicios">
        @for (servicio of servicios; track servicio.icon; let i = $index) {
          <div class="tarjeta-servicio">
            <div class="icono-servicio">
              <img [src]="'assets/svg/' + servicio.icon" [alt]="servicio.title">
            </div>
            <div class="contenido-tarjeta">
              <h3>{{ servicio.title }}</h3>
              <button class="boton-servicio">
                <a [routerLink]="['/servicios']" [queryParams]="{ id: i + 1 }">Ir al servicio</a>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- Sección Sobre Nosotros -->
  <section class="seccion-nosotros">
    <div class="contenedor">
      <div class="contenido-nosotros">
        <div class="imagen-nosotros"></div>
        <div class="texto-nosotros">
          <div class="tarjeta-nosotros">
            <div class="circulo-azul circulo-azul-nosotros"></div>
            <h2>Sobre <span>nosotros.</span></h2>
            <p>Somos una empresa con más de 30 años de experiencia, especializada en brindar soluciones integrales para el abastecimiento del recurso hídrico, que gestiona proyectos desde la consultoría hasta su ejecución y puesta en marcha, orientados a cubrir las diversas necesidades de los sectores construcción, industrial, minero, agroindustrial y otros rubros afines. Contamos con un <span>equipo profesional altamente calificado y el respaldo operativo</span> para desarrollar proyectos de alto impacto con eficiencia, calidad y compromiso.</p>
            <button class="boton-principal btn-nosotros">
              <a routerLink="/nosotros">Conoce más aquí</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección ANA -->
  <section class="seccion-ana">
    <div class="contenedor">
      <div class="contenido-ana">
        <div class="texto-ana">
          <h2>Autorizados por el ANA</h2>
          <p>Corporación REHOBOT cuenta con autorización oficial de la Autoridad Nacional del Agua (ANA) para realizar actividades de <span>perforación, equipamiento, rehabilitación y mantenimiento de pozos de agua</span>, lo que garantiza el cumplimiento de la normativa vigente y respalda nuestra capacidad técnica y legal.</p>
          <button class="btn-ANA">
            <a routerLink="/contacto">Contáctanos</a>
          </button>
        </div>
        <div class="logo-ana">
          <div class="imagen-ana">
            <img src="assets/img/ANA.jpg" alt="Logo ANA">
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección Territorio -->
  <section class="seccion-territorio">
    <div class="contenedor">
      <div class="contenido-territorio">
        <div class="mapa-peru"></div>
        <div class="texto-territorio">
          <div class="circulo-azul circulo-azul-TN"></div>
          <div class="texto-TN">
            <h2>Ejecutamos proyectos en todo el <span>territorio nacional.</span></h2>
            <button class="btn-territorio">
              <a routerLink="/contacto">Contáctanos</a>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección Clientes -->
  <section class="seccion-clientes">
    <div class="contenedor">
      <h2>Nuestros clientes nos <span>respaldan.</span></h2>
      <div class="carrusel-clientes">
        <div class="logos-clientes">
          @for (cliente of clientes; track cliente.name) {
            <div class="logo-cliente">
              <img [src]="cliente.img" [alt]="cliente.name">
            </div>
          }
          @for (cliente of clientes; track cliente.name + '_2') {
            <div class="logo-cliente">
              <img [src]="cliente.img" [alt]="cliente.name">
            </div>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- Sección Marcas -->
  <section class="seccion-marcas">
    <div class="contenedor">
      <div class="marcas-contenedor">
        <div class="circulo-marcas circulo-azul"></div>
        <h2>Trabajamos con las mejores <span>marcas.</span></h2>
        <div class="logos-marcas">
          @for (marca of marcas; track marca.name) {
            <img class="logo-marca" [src]="marca.img" [alt]="marca.name">
          }
        </div>
      </div>
    </div>
  </section>
</main>
